// extracted by mini-css-extract-plugin
module.exports = {"nomargin":"PlayButton_nomargin__kP51z"};